import { mainSiteUrl } from '@/mocks/categories';
import { heroContent } from '@/mocks/seo-content';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20artistic%20product%20collage%20with%20minimalist%20fashion%20items%20floating%20on%20warm%20beige%20background%2C%20elegant%20geometric%20spreadsheet%20grid%20lines%20subtly%20overlaid%2C%20pastel%20terracotta%20and%20sage%20accents%2C%20delicate%20fabric%20textures%2C%20dreamy%20editorial%20composition%2C%20no%20text%2C%20soft%20atmospheric%20lighting%2C%20modern%20minimal%20design&width=1800&height=1200&seq=hero-main-v3-2026&orientation=landscape"
          alt="Pandabuyspreadsheet shopping discovery system"
          title="Pandabuyspreadsheet – smart shopping spreadsheet comparison"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-3xl mx-auto">
          {/* Tag line */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/25 bg-background-50/10 backdrop-blur-sm mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span className="text-xs text-background-50/90 font-medium tracking-wide uppercase">
              Smart Shopping Spreadsheet System 2026
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight tracking-tight">
            {heroContent.headline}
          </h1>

          <p className="mt-5 text-sm md:text-base text-background-50/75 max-w-xl mx-auto leading-relaxed">
            {heroContent.subheadline}
          </p>

          {/* Dual CTA */}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
            >
              Pandabuy Sheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}